'use client';

import Grid from '@gds/Grid/Grid';
import { Tick } from '@gds/Icons';
import { Typography } from '@gds/Typography/Typography';
import { FullWidth } from '@page-builder/Components/FullWidth/FullWidth';

import Image from 'next/image';

import CarsaleLogo from './Images/carsale24.png';
import InputForm from './InputForm';

import styles from './DeValuationHero.module.css';

interface Props {
  backgroundColor: string;
  image: Array<string>;
  header: string;
  inputFormTitle: string;
  infoTitle: string;
  bulletPoint1: string;
  bulletPoint2: string;
  bulletPoint3: string;
}

const DeValuationHero = ({
  backgroundColor,
  image,
  header,
  inputFormTitle,
  infoTitle,
  bulletPoint1,
  bulletPoint2,
  bulletPoint3,
}: Props) => {
  const ImageWrapper = 'span';
  const wrapperStyle = { background: backgroundColor };

  return (
    <>
      <FullWidth>
        <div style={wrapperStyle} id="valuation-hero">
          <Grid.Container className={styles.heroWrapper}>
            <div className={styles.textWrapper}>
              <Typography className={styles.heading} variant="h1">
                <span>{header}</span>
              </Typography>
              <div className={styles.mobileImageContainer}>
                <Image src={image[0]} alt="Photo of a car" width={800} height={80} />
              </div>
            </div>
            <ImageWrapper className={styles.imageWrapper}>
              <div className={styles.imageContainer}>
                <Image src={image[0]} alt="Photo of a car" width={800} height={800} />
              </div>
            </ImageWrapper>
          </Grid.Container>
        </div>
      </FullWidth>
      <div className={styles.heroContent}>
        <InputForm inputFormTitle={inputFormTitle} />
        <div className={styles.infoWrapper}>
          <Typography variant="h4">{infoTitle}</Typography>
          <div className={styles.bulletPoint}>
            <Tick />
            <Typography variant="subheading2">{bulletPoint1}</Typography>
          </div>
          <div className={styles.bulletPoint}>
            <Tick />
            <Typography variant="subheading2">{bulletPoint2}</Typography>
          </div>
          <div className={styles.bulletPoint}>
            <Tick />
            <Typography variant="subheading2">{bulletPoint3}</Typography>
          </div>
          <Image
            loading="lazy"
            src={CarsaleLogo}
            width={140}
            className={styles.logo}
            alt={'Carsale logo'}
          />
        </div>
      </div>
    </>
  );
};

export default DeValuationHero;
